import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["mode", "radiusFields"];

  connect() {
    this.toggleRadius();
  }

  toggleRadius() {
    const hidden = this.modeTarget.value !== "radius";

    this.radiusFieldsTarget.classList.toggle("tw-hidden", hidden);
    this.radiusFieldsTarget.setAttribute("aria-hidden", hidden.toString());
  }
}
